import React from "react";

/* ============================================================================
 * HomeCategories — แถวไอคอนหมวดหมู่ยอดนิยม (คั่นระหว่างกล่องค้นหากับแบนเนอร์)
 *
 * เป็นทางลัดไปยังผลค้นหาที่คนกดบ่อย ไม่ต้องเปิดกล่องค้นหาแล้วเลือกทีละช่อง
 * รายการ/ไอคอน/ลำดับ แก้ไขได้จากหลังบ้าน (/ad/home/shortcuts)
 * ข้อมูลส่งมาจากหน้าแม่ (GET home/content) — กรองเฉพาะที่เปิดใช้งานและเรียงมาแล้ว
 * จอเล็กเลื่อนแนวนอนได้ ไม่ยุบเป็นหลายบรรทัด เพื่อคงจังหวะสายตาแถวเดียว
 * ========================================================================== */
export default function HomeCategories({ items = [], onSelect }) {
  if (!items.length) return null;

  return (
    <div className="hm-container">
      <div className="hm-cats">
        {items.map((item) => (
          <button key={item.uid} type="button" className="hm-cat" onClick={() => onSelect && onSelect(item)}>
            <span className="hm-cat__icon hm-ico">{item.icon}</span>
            <span className="hm-cat__label">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
